export default "__VITE_ASSET__Dd4ju$m6__"